import script from "./BodySubFeatures.vue?vue&type=script&setup=true&lang=js"
export * from "./BodySubFeatures.vue?vue&type=script&setup=true&lang=js"

const cssModules = {}
import style0 from "./BodySubFeatures.vue?vue&type=style&index=0&id=30032af0&module=features&lang=css"
cssModules["features"] = style0
import "./BodySubFeatures.vue?vue&type=style&index=1&id=30032af0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules],['__scopeId',"data-v-30032af0"]])

export default __exports__